<template>
  <transition name="fade" appear>
    <div class="modal-mask">
      <div class="modal-wrapper" @mousedown="$emit('close')">
        <div class="modal-container">
          <slot name="modal-body"></slot>
          <div class="footer">
            <div v-if="btnCount === 1" @click="close">
              <button class="footer-button green" @click="click">
                {{ label }}
              </button>
            </div>
            <div v-if="btnCount === 2" class="buttons">
              <button class="footer-button left" @click="clickLeft">
                {{ labelLeft }}
              </button>
              <button class="footer-button right" @click="clickRight">
                {{ labelRight }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    item: Object,
    btnCount: Number,
    label: String,
    labelLeft: String,
    labelRight: String,
    title: String,
  },
  mounted() {
    window.addEventListener("resize", this.check_screenWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.check_screenWidth);
  },
  methods: {
    check_screenWidth() {
      return screen.width >= 767;
    },
    close() {
      this.$emit("close");
    },
    click() {
      this.$emit("click");
    },
    clickLeft() {
      this.$emit("click-left");
    },
    clickRight() {
      this.$emit("click-right");
    },

    closeModal() {
      if (!this.clickToClose) {
        return;
      }

      this.closeEvent();
    },
    closeEvent() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  position: relative;
  width: 30vw;
  max-height: 70vh;
  margin: 0px auto;
  padding: 60px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  overflow-y: scroll;
}

.modal-body {
  padding-bottom: 50px;
  margin-top: 36px;
}

.modal-default-button {
  position: fixed;
  /* top: 10vh;
  left: 65vw; */
  top: 10px;
  right: 10px;
  /* background-color: #9a9a9a; */
  padding: 0.2rem;
  width: 60px;
  height: 60px;
}
.modal-default-button img {
  width: 100%;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}
.modal-container {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.modal-container::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera*/
}
.footer {
  width: 100%;
}

.footer-button {
  width: 100%;
  height: 60px;

  border: none;
  outline: none;
  box-sizing: border-box;
  text-align: center;
  color: #ffff;
  cursor: pointer;
  text-align: center;
  font: normal normal 400 20px / 29px;
  letter-spacing: 0;
}

.buttons {
  display: flex;
  flex: 1;
}

.left {
}

.right {
}
</style>
